import { useMutation } from "react-query";
import { getOfficeByIdList } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

const useOfficeForDownload = () => {
  return useMutation(getOfficeByIdList);
};
export default useOfficeForDownload;
